import {
  CircularProgress,
  Divider,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from "@material-ui/core";
import {
  forwardRef,
  // useCallback,
  // useContext,
  useEffect,
  useState,
} from "react";
import { handleAxiosError } from "../../../../../common/data/axiosErrorHandler";
import {
  MaintenanceDashboardApiFactory,
  VehiclesConditionOutput,
} from "../../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../../common/hooks/useAxiosInstance";
import { WidgetProps } from "../../common";
import { Widget } from "../Widget";
import { WidgetCircularValue } from "../WidgetCircularValue";

const useStyles = makeStyles((theme: Theme) => ({
  total: {
    color: theme.palette.info.main,
  },
  vertical: {
    height: "75%",
  },
  colorWarning: {
    color: theme.palette.warning.main,
  },
  colorSuccess: {
    color: theme.palette.success.main,
  },
  colorError: {
    color: theme.palette.error.main,
  },
}));

export const VehiclesCondition = forwardRef((props: WidgetProps, ref) => {
  const { className, icon, title, ...rest } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const axios = useAxiosInstance();
  const theme = useTheme<Theme>();
  // const filterContext = useContext(SelectedFilterContext);
  const [total, setTotal] = useState<VehiclesConditionOutput>();
  const classes = useStyles();

  useEffect(() => {
    if (!axios) {
      return;
    }

    setLoading(true);
    MaintenanceDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
      .apiAppMaintenancedashboardVehiclesconditionGet()
      .then((result) => {
        setTotal(result.data);
      })
      .catch((e) => console.error(handleAxiosError(e)))
      .finally(() => setLoading(false));
  }, [axios]);

  // const handleGoodClick = useCallback(() => {
  //   if (!filterContext || !total?.good) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_GOOD");
  // }, [filterContext, total]);

  // const handleSatisfactoryClick = useCallback(() => {
  //   if (!filterContext || !total?.satisfactory) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_SATISFACTORY");
  // }, [filterContext, total]);

  // const handleCriticalClick = useCallback(() => {
  //   if (!filterContext || !total?.critical) {
  //     return;
  //   }

  //   filterContext.setSelectedFilter("WITH_CONDITION_CRITICAL");
  // }, [filterContext, total]);

  return (
    <Widget title={title} icon={icon} className={className} ref={ref} {...rest}>
      <div className="categories">
        {loading ? (
          <div className="category">
            <CircularProgress size="3rem" />
          </div>
        ) : (
          <>
            <div className="category vehicles-condition">
              <div className="category-title">
                <Typography variant="body1" component="div">
                  Good
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.goodPercentage}
                valueLabel={(total?.goodPercentage?.toFixed(0) ?? 0) + "%"}
                primaryColor={theme.palette.success.main}
              />
              <div className="category-caption">
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorSuccess}
                >
                  {total?.good ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Vehicles
                </Typography>
              </div>
            </div>
            <Divider
              orientation="vertical"
              classes={{ vertical: classes.vertical }}
            />
            <div className="category vehicles-condition">
              <div className="category-title">
                <Typography variant="body1" component="div">
                  Satisfactory
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.satisfactoryPercentage}
                valueLabel={
                  (total?.satisfactoryPercentage?.toFixed(0) ?? 0) + "%"
                }
                primaryColor={theme.palette.warning.main}
              />
              <div className="category-caption">
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorWarning}
                >
                  {total?.satisfactory ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Vehicles
                </Typography>
              </div>
            </div>
            <Divider
              orientation="vertical"
              classes={{ vertical: classes.vertical }}
            />
            <div className="category vehicles-condition">
              <div className="category-title">
                <Typography variant="body1" component="div">
                  Critical
                </Typography>
              </div>
              <WidgetCircularValue
                value={total?.criticalPercentage}
                valueLabel={(total?.criticalPercentage?.toFixed(0) ?? 0) + "%"}
                primaryColor={theme.palette.error.main}
              />
              <div className="category-caption">
                <Typography
                  variant="h4"
                  component="div"
                  className={classes.colorError}
                >
                  {total?.critical ?? 0}
                </Typography>
                <Typography variant="body2" component="div">
                  Vehicles
                </Typography>
              </div>
            </div>
          </>
        )}
      </div>
    </Widget>
  );
});
